<div class="mismatch-indicator w-100 mb-2">
  <span class="title">
    {{
      'page.shift_timeline.activity_drawer.location_mismatch_indicator.title'
        | translate
    }}</span
  >
</div>
